import { IdDocumentState } from './id-document.interfaces';

export const initialState = {} as IdDocumentState;
